import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./TeacherDetails.css";
import axios from "axios";
import { baseUrl, userRoles } from "../../../../Utility/constants";
import { toast } from "react-toastify";

const AddNewTeacherModal = ({
  showAddNew,
  handleCloseNewTeacher,
  handleNewTeacherSubmit,
  newTeacherItem,
  setNewTeacherItem
}) => {

  const [genderMaster, setGenderMaster] = useState([]);
  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState({});

  const [dropdowns, setDropdowns] = useState({
    grantTypes: [],
    categoriesResponse: []
  });

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [
          grantTypeRes,
          categoriesRes
        ] = await Promise.all([
          axios.get(`${baseUrl}/api/CommonMaster/GetGrantTypeMasters`),
          axios.get(`${baseUrl}/api/CategoryMaster`),
        ]);

        setDropdowns({
          grantTypes: grantTypeRes.data,
        });
        setCategories(categoriesRes.data)
      } catch (error) {
        console.log("Failed to fetch dropdown data");
      }
    };

    fetchDropdowns();
  }, []);


  useEffect(() => {
    axios
      .get(`${baseUrl}/api/CommonMaster/GetGenderMasters`)
      .then((response) => {
        setGenderMaster(response.data);
      })
      .catch((error) => {
        console.log("Failed to load gender details.");
      });
  }, []);

  const validateForm = () => {
  let errors = [];

  if (!newTeacherItem.fullName)
    errors.push("Full Name is required");

  if (!newTeacherItem.gender)
    errors.push("Gender is required");

  if (!newTeacherItem.dateOfBirth)
    errors.push("Date of Birth is required");

  if (!newTeacherItem.joiningDate)
    errors.push("Joining Date is required");

  if (!newTeacherItem.phone)
    errors.push("Phone number is required");
  else if (newTeacherItem.phone.length !== 10)
    errors.push("Phone number must be 10 digits");

  if (!newTeacherItem.email)
    errors.push("Email is required");

  if (!newTeacherItem.password)
    errors.push("Password is required");

  if (!newTeacherItem.role)
    errors.push("Role is required");

  if (!newTeacherItem.aadhaarCardNumber)
    errors.push("Aadhaar number is required");
  else if (newTeacherItem.aadhaarCardNumber.length !== 12)
    errors.push("Aadhaar must be 12 digits");

  // Conditional validation
  if (newTeacherItem.vaiyaktikManyata === "YES") {
    if (!newTeacherItem.vaiyaktikManyataDate)
      errors.push("Manyata Date is required");

    if (!newTeacherItem.vaiyaktikManyataOutwardNumber)
      errors.push("Manyata Outward Number is required");

    if (!newTeacherItem.vaiyaktikManyataPhoto)
      errors.push("Manyata Photo is required");
  }

  if (errors.length > 0) {
    errors.forEach((msg) => toast.error(msg));
    return false;
  }

  return true;
};



  const calculateRetirementDate = (dob) => {
    const retirementYear = dob.getFullYear() + 58;
    const dobDay = dob.getDate();

    let retirementDateObj;

    if (dobDay === 1) {
      // Last day of previous month
      retirementDateObj = new Date(retirementYear, dob.getMonth(), 0);
    } else {
      // Last day of current month
      retirementDateObj = new Date(retirementYear, dob.getMonth() + 1, 0);
    }

    // Convert to yyyy-mm-dd string for input[type="date"]
    return retirementDateObj.toISOString().split("T")[0];
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    let updatedFields = {};

    if (name === "dateOfBirth") {
      const dob = new Date(value);

      if (!isNaN(dob)) {
        const retirementDate = calculateRetirementDate(dob);
        updatedFields.retirementDate = retirementDate;
      }
    }

    setNewTeacherItem((prev) => ({
      ...prev,
      [name]: updatedValue,
      ...updatedFields,
    }));
  };

  const handleNumberChange = (e, maxLength) => {
    const { name, value } = e.target;

    // Allow only numbers
    if (!/^\d*$/.test(value)) return;

    // Enforce max length
    if (value.length > maxLength) return;

    setNewTeacherItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    setNewTeacherItem((prev) => ({
      ...prev,
      [name]: file
    }));
  };
  const handleFile_Change = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];

    if (!file) return;

    // 1. Allow only PDF file
    if (file.type !== "application/pdf") {
      alert("Only PDF files are allowed.");
      e.target.value = ""; // reset input
      return;
    }

    // 2. Size must be <= 512 KB
    const maxSize = 512 * 1024; // 512KB in bytes
    if (file.size > maxSize) {
      alert("File size must not exceed 512KB.");
      e.target.value = ""; // reset input
      return;
    }

    // If validations pass, save file to state
    setNewTeacherItem((prev) => ({
      ...prev,
      [name]: file
    }));
  };


  return (
    <Modal
      show={showAddNew}
      onHide={handleCloseNewTeacher}
      dialogClassName="teacher-custom-modal-lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New User</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form
          onSubmit={(e) => {
            e.preventDefault();

            if (!validateForm()) return;

            handleNewTeacherSubmit(e); // call actual submit
          }}
        >

          {/* ---------------- BASIC DETAILS ---------------- */}
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formFullName">
                <Form.Label>Full Name <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="fullName"
                  value={newTeacherItem.fullName || ""}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formGender">
                <Form.Label>Gender <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  as="select"
                  name="gender"
                  value={newTeacherItem.gender || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select gender</option>
                  {genderMaster.map((item, index) => (
                    <option key={index} value={item.id}>{item.name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formDateOfBirth">
                <Form.Label>Date of Birth <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="date"
                  name="dateOfBirth"
                  value={newTeacherItem.dateOfBirth || ""}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formJoiningDate">
                <Form.Label>Joining Date <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="date"
                  name="joiningDate"
                  value={newTeacherItem.joiningDate || ""}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ---------------- ADDRESS / CONTACT ---------------- */}
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  value={newTeacherItem.address || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formPhone">
                <Form.Label>Phone<span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={newTeacherItem.phone || ""}
                  //onChange={handleInputChange}
                  onChange={(e) => handleNumberChange(e, 10)}
                  maxLength={10}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formEmail">
                <Form.Label>Email <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={newTeacherItem.email || ""}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formPassword">
                <Form.Label>Password <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="password"
                  value={newTeacherItem.password || ""}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ---------------- SALARY + ROLE ---------------- */}
          <Row className="mb-3">
            {/* <Col md={3}>
              <Form.Group controlId="formSalary">
                <Form.Label>Salary</Form.Label>
                <Form.Control
                  type="number"
                  name="salary"
                  value={newTeacherItem.salary || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col> */}

            <Col md={3}>
              <Form.Group controlId="formRole">
                <Form.Label>Role <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  as="select"
                  name="role"
                  value={newTeacherItem.role || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Role</option>
                  {userRoles.map((item, index) => (
                    <option key={index} value={item.id}>{item.name}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formTeacherType">
                <Form.Label>Type</Form.Label>
                <Form.Control
                  as="select"
                  name="teacherType"
                  value={newTeacherItem.teacherType || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Type</option>
                  <option value="Permanent">Permanent</option>
                  <option value="Temporary">Temporary</option>
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formTeacherDesignation">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  as="select"
                  name="designation"
                  value={newTeacherItem.designation || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Designation</option>
                  <option value="Principal (D.Ed)">Principal (D.Ed)</option>
                  <option value="Principal">Principal</option>
                  <option value="Headmaster">Headmaster</option>
                  <option value="Headmaster (Cantonment)">Headmaster (Cantonment)</option>
                  <option value="Assistant Headmaster">Assistant Headmaster</option>
                  <option value="Supervisor">Supervisor</option>
                  <option value="Special Teacher">Special Teacher</option>
                  <option value="Lab Assistant">Lab Assistant</option>
                  <option value="Lab Attendant">Lab Attendant</option>
                  <option value="Commandant">Commandant</option>
                  <option value="Assistant Teacher">Assistant Teacher</option>
                  <option value="PARA Teacher">PARA Teacher</option>
                  <option value="Drawing Teacher">Drawing Teacher</option>
                  <option value="Music Teacher">Music Teacher</option>
                  <option value="Physical Teacher">Physical Teacher</option>
                  <option value="Shikshan Sevak">Shikshan Sevak</option>
                  <option value="Military Instructor">Military Instructor</option>
                  <option value="Superitendent">Superitendent</option>
                  <option value="Head Clerk">Head Clerk</option>
                  <option value="Sr. Clerk">Sr. Clerk</option>
                  <option value="Jr. Clerk">Jr. Clerk</option>
                  <option value="Jr. Clerk (Sevak)">Jr. Clerk (Sevak)</option>
                  <option value="Naik">Naik</option>
                  <option value="Liberian (Full Time)">Liberian (Full Time)</option>
                  <option value="Liberian (Part Time)">Liberian (Part Time)</option>
                  <option value="Computer Instructor">Computer Instructor</option>
                  <option value="Part Time Assist.Teacher">Part Time Assist.Teacher</option>
                  <option value="Part Time Peon">Part Time Peon</option>
                  <option value="Jr.College Teacher">Jr.College Teacher</option>
                  <option value="Part Time Jr.College Teacher">Part Time Jr.College Teacher</option>
                  <option value="C.H.B">C.H.B</option>
                  <option value="Lecturer">Lecturer</option>
                  <option value="Assistant Teacher (Cantonment)">Assistant Teacher (Cantonment)</option>
                  <option value="Assistant Teacher  Graduate (Cantonment)">Assistant Teacher  Graduate (Cantonment)</option>
                  <option value="Craft Lecturer">Craft Lecturer</option>
                  <option value="Kendra Pramukh">Kendra Pramukh</option>
                  <option value="Librarian (Sevak)">Librarian (Sevak)</option>
                  <option value="Mess Manager (Bhonsala Military)">Mess Manager (Bhonsala Military)</option>
                  <option value="Training Officer (Bhonsala Military)">Training Officer (Bhonsala Military)</option>
                  <option value="Chief Training Officer (Bhonsala Military)">Chief Training Officer (Bhonsala Military)</option>
                  <option value="Assistant Training Officer (Bhonsala Military)">Assistant Training Officer (Bhonsala Military)</option>
                  <option value="State Secretary">State Secretary</option>
                  <option value="Joint State Secretary">Joint State Secretary</option>
                  <option value="Assistant State Secretary">Assistant State Secretary</option>
                  <option value="State Training Commissioner (Scouts)">State Training Commissioner (Scouts)</option>
                  <option value="State Training Commissioner (Guides)">State Training Commissioner (Guides)</option>
                  <option value="Assistant State Organising Commissioner">Assistant State Organising Commissioner</option>
                  <option value="Assistant State Traning Commissioner">Assistant State Traning Commissioner</option>
                  <option value="Civil Engineer">Civil Engineer</option>
                  <option value="Pubic Relation Officer">Pubic Relation Officer</option>
                  <option value="District Organising Commissioner">District Organising Commissioner</option>
                  <option value="District Organizer">District Organizer</option>
                  <option value="Assistant Organising Commissioner">Assistant Organising Commissioner</option>
                  <option value="District Scout Organizer">District Scout Organizer</option>
                  <option value="District Guide Organizer">District Guide Organizer</option>
                  <option value="District Scout/Guide Organizer">District Scout/Guide Organizer</option>
                  <option value="Assistant Accountant">Assistant Accountant</option>
                  <option value="Cashier">Cashier</option>
                  <option value="Typist">Typist</option>
                  <option value="Driver">Driver</option>
                  <option value="Chowkidar">Chowkidar</option>
                  <option value="State Organizing Commissioner (Scouts)">State Organizing Commissioner (Scouts)</option>
                  <option value="State Organizing Commissioner (Guides)">State Organizing Commissioner (Guides)</option>
                  <option value="Stenographer">Stenographer</option>
                  <option value="Framing/Agriculture Assistant">Framing/Agriculture Assistant</option>
                  <option value="Co-Ordinator">Co-Ordinator</option>
                  <option value="Accountant">Accountant</option>
                  <option value="Under Graduate Teacher">Under Graduate Teacher</option>
                  <option value="Graduate Teacher (6 to 8)">Graduate Teacher (6 to 8)</option>
                  <option value="Graduate Teacher (9 to 10)">Graduate Teacher (9 to 10)</option>
                  <option value="Post Graduate Teacher (D.Ed)">Post Graduate Teacher (D.Ed)</option>
                  <option value="Post Graduate Teacher">Post Graduate Teacher</option>
                  <option value="Peon">Peon</option>
                  <option value="Traning Instructor">Traning Instructor</option>
                  <option value="Special Teacher (Music+Tabalji)">Special Teacher (Music+Tabalji)</option>
                  <option value="Special Teacher (Physical Education)">Special Teacher (Physical Education)</option>
                  <option value="Special Craft">Special Craft</option>
                  <option value="Farming Helper">Farming Helper</option>

                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formAadhaar">
                <Form.Label>Aadhaar Card Number <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="aadhaarCardNumber"
                  value={newTeacherItem.aadhaarCardNumber || ""}
                  //onChange={handleInputChange}
                  onChange={(e) => handleNumberChange(e, 12)}
                  maxLength={12}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formGrantType">
                <Form.Label>Grant Type</Form.Label>
                <Form.Control
                  as="select"
                  name="grantTypes"
                  value={newTeacherItem.grantTypes || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Grant</option>
                  {dropdowns.grantTypes.map((grant) => (
                    <option key={grant.id} value={grant.id}>
                      {grant.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formEducation">
                <Form.Label>Educational Qualification</Form.Label>
                <Form.Control
                  type="text"
                  name="educationalQualification"
                  value={newTeacherItem.educationalQualification || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formPayScale">
                <Form.Label>Pay Scale Salary</Form.Label>
                <Form.Control
                  as="select"
                  name="payScaleSalary"
                  value={newTeacherItem.payScaleSalary || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Pay Scale</option>
                  <option value="S1-15000-47600 Grade Pay(1300)">S1-15000-47600 Grade Pay(1300)</option>
                  <option value="S2-15300-48700 Grade Pay(1400)">S2-15300-48700 Grade Pay(1400)</option>
                  <option value="S3-16600-52400 Grade Pay(1600)">S3-16600-52400 Grade Pay(1600)</option>
                  <option value="S4-1-17100-54000 Grade Pay(1650)">S4-1-17100-54000 Grade Pay(1650)</option>
                  <option value="S4-1-17100-54000 Grade Pay(1700)">S4-1-17100-54000 Grade Pay(1700)</option>
                  <option value="S5-18000-56900 Grade Pay(1800)">S5-18000-56900 Grade Pay(1800)</option>
                  <option value="S6-19900-63200 Grade Pay(1900)">S6-19900-63200 Grade Pay(1900)</option>
                  <option value="S7-21700-69100 Grade Pay(2000)">S7-21700-69100 Grade Pay(2000)</option>
                  <option value="S8-25500-81100 Grade Pay(2400)">S8-25500-81100 Grade Pay(2400)</option>
                  <option value="S9-26400-83600 Grade Pay(2500)">S9-26400-83600 Grade Pay(2500)</option>
                  <option value="S10-29200-92300 Grade Pay(2800)">S10-29200-92300 Grade Pay(2800)</option>
                  <option value="S11-30100-95100 Grade Pay(2900)">S11-30100-95100 Grade Pay(2900)</option>
                  <option value="S12-32000-101600 Grade Pay(3500)">S12-32000-101600 Grade Pay(3500)</option>
                  <option value="S13-1-35400-112400 Grade Pay(4100)">S13-1-35400-112400 Grade Pay(4100)</option>
                  <option value="S13-2-35400-112400 Grade Pay(4200)">S13-2-35400-112400 Grade Pay(4200)</option>
                  <option value="S14-38600-122800 Grade Pay(4300)">S14-38600-122800 Grade Pay(4300)</option>
                  <option value="S15-41800-132300 Grade Pay(4400)">S15-41800-132300 Grade Pay(4400)</option>
                  <option value="S16-1-44900-142400 Grade Pay(4500)">S16-1-44900-142400 Grade Pay(4500)</option>
                  <option value="S16-2-44900-142400 Grade Pay(4600)">S16-2-44900-142400 Grade Pay(4600)</option>
                  <option value="S17-47600-151100 Grade Pay(4800)">S17-47600-151100 Grade Pay(4800)</option>
                  <option value="S18-1-49100-155800 Grade Pay(4900)">S18-1-49100-155800 Grade Pay(4900)</option>
                  <option value="S18-2-49100-155800 Grade Pay(5000)">S18-2-49100-155800 Grade Pay(5000)</option>
                  <option value="S19-55100-175100 Grade Pay(5000)">S19-55100-175100 Grade Pay(5000)</option>
                  <option value="S20-1-56100-177500 Grade Pay(5400)">S20-1-56100-177500 Grade Pay(5400)</option>
                  <option value="S20-2-56100-177500 Grade Pay(5400)">S20-2-56100-177500 Grade Pay(5400)</option>
                  <option value="S21-57100-180800 Grade Pay(5500)">S21-57100-180800 Grade Pay(5500)</option>
                  <option value="S22-1-60000-190800 Grade Pay(5700)">S22-1-60000-190800 Grade Pay(5700)</option>
                  <option value="S22-2-60000-190800 Grade Pay(5800)">S22-2-60000-190800 Grade Pay(5800)</option>
                  <option value="S23-67700-0 Grade Pay(6600)">S23-67700-0 Grade Pay(6600)</option>
                  <option value="S24-71100-0 Grade Pay(6900)">S24-71100-0 Grade Pay(6900)</option>
                  <option value="S25-78800-0 Grade Pay(7600)">S25-78800-0 Grade Pay(7600)</option>
                  <option value="S26-82200-0 Grade Pay(7900)">S26-82200-0 Grade Pay(7900)</option>
                  <option value="S27-118500-0 Grade Pay(8700)">S27-118500-0 Grade Pay(8700)</option>
                  <option value="S28-124800-0 Grade Pay(8800)">S28-124800-0 Grade Pay(8800)</option>
                  <option value="S29-131100-0 Grade Pay(8900)">S29-131100-0 Grade Pay(8900)</option>
                  <option value="S30-144200-0 Grade Pay(10000)">S30-144200-0 Grade Pay(10000)</option>
                  <option value="S31-182200-0 Grade Pay(0)">S31-182200-0 Grade Pay(0)</option>
                  <option value="L-1 7500-23500 GP(650)">L-1 7500-23500 GP(650)</option>
                  <option value="L-2 9950-31200 GP(950)">L-2 9950-31200 GP(950)</option>
                  <option value="L-3 10850-34400 GP(1000)">L-3 10850-34400 GP(1000)</option>
                  <option value="L-4 12750-40200 GP(1200)">L-4 12750-40200 GP(1200)</option>
                  <option value="L-5 14600-46200 GP(1400)">L-5 14600-46200 GP(1400)</option>
                  <option value="L-6 19300-61400 GP(2150)">L-6 19300-61400 GP(2150)</option>
                  <option value="L-7 22450-71200 GP(2300)">L-7 22450-71200 GP(2300)</option>
                  <option value="L-8 23800-75500 GP(2400)">L-8 23800-75500 GP(2400)</option>
                  <option value="L-9 24500-78200 GP(2450)">L-9 24500-78200 GP(2450)</option>
                  <option value="Rs.5000/-">Rs.5000/-</option>
                  <option value="Rs.2500/-">Rs.2500/-</option>
                  <option value="Rs.9000/-">Rs.9000/-</option>
                  <option value="Rs.4500/-">Rs.4500/-</option>
                  <option value="Rs.72/- Per Hour">Rs.72/- Per Hour</option>
                  <option value="0">0</option>
                  <option value="Rs.120/- Per Hour">Rs.120/- Per Hour</option>
                  <option value="Rs.150/- Per Hour">Rs.150/- Per Hour</option>
                  <option value="Rs.10000/-">Rs.10000/-</option>
                  <option value="Rs.12000/-">Rs.12000/-</option>
                  <option value="Rs.20000/-">Rs.20000/-</option>

                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formChartType">
                <Form.Label>Chart Type</Form.Label>
                <Form.Control
                  as="select"
                  name="chartType"
                  value={newTeacherItem.chartType || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Chart</option>
                  <option value="A (Full Time Permanent Recognized Teachers, Non-Teaching Staff)">A (Full Time Permanent Recognized Teachers, Non-Teaching Staff)</option>
                  <option value="B (Full Time Recognized Teachers, Education servants, Non-Teaching Employees)">B (Full Time Recognized Teachers, Education servants, Non-Teaching Employees)</option>
                  <option value="C (Part Time Recognized Teachers, Education servant)">C (Part Time Recognized Teachers, Education servant)</option>
                  <option value="D (Part Time Teacher (on G.T.Basis) Acceptable/Not Acceptable)">D (Part Time Teacher (on G.T.Basis) Acceptable/Not Acceptable)</option>
                  <option value="E (Newly Appointed Full Time/Part Time Teachers/Non Teaching Staff (Non Accredited))">E (Newly Appointed Full Time/Part Time Teachers/Non Teaching Staff (Non Accredited))</option>
                  <option value="C1 (Permanent Unaided Full Time/Part Time Recognized Teacher)">C1 (Permanent Unaided Full Time/Part Time Recognized Teacher)</option>

                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formPostType">
                <Form.Label>Post Type</Form.Label>
                <Form.Control
                  as="select"
                  name="postType"
                  value={newTeacherItem.postType || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Post</option>
                  <option value="Full Time">Full Time</option>
                  <option value="Part Time">Part Time</option>
                  <option value="C.H.B">C.H.B</option>
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formRetirementDate">
                <Form.Label>Retirement Date</Form.Label>
                <Form.Control
                  type="date"
                  name="retirementDate"
                  value={newTeacherItem.retirementDate || ""}
                  //onChange={handleInputChange}
                  disabled
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formPayGradeSanctionedDate">
                <Form.Label>Pay Grade Sanctioned Date</Form.Label>
                <Form.Control
                  type="date"
                  name="payGradeSanctionedDate"
                  value={newTeacherItem.payGradeSanctionedDate || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formSelectionCategoryApprovedDate">
                <Form.Label>Selection Category Approved Date</Form.Label>
                <Form.Control
                  type="date"
                  name="selectionCategoryApprovedDate"
                  value={newTeacherItem.selectionCategoryApprovedDate || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formTeacherCategoryId">
                <Form.Label>Caste Category</Form.Label>
                <Form.Control
                  as="select"
                  name="teacherCategoryId"
                  value={newTeacherItem.teacherCategoryId || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select Category</option>
                  {categories.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formVaiyaktikManyata">
                <Form.Label>Vaiyaktik Manyata</Form.Label>
                <Form.Control
                  as="select"
                  name="vaiyaktikManyata"
                  value={newTeacherItem.vaiyaktikManyata || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </Form.Control>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formVaiyaktikManyataDate">
                <Form.Label>Manyata Date</Form.Label>
                <Form.Control
                  type="date"
                  name="vaiyaktikManyataDate"
                  value={newTeacherItem.vaiyaktikManyataDate || ""}
                  onChange={handleInputChange}
                  disabled={newTeacherItem.vaiyaktikManyata === "NO"}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}>
              <Form.Group controlId="formVaiyaktikManyataOutwardNumber">
                <Form.Label>Manyata Outward Number</Form.Label>
                <Form.Control
                  type="text"
                  name="vaiyaktikManyataOutwardNumber"
                  value={newTeacherItem.vaiyaktikManyataOutwardNumber || ""}
                  onChange={handleInputChange}
                  disabled={newTeacherItem.vaiyaktikManyata === "NO"}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formManyataPhoto">
                <Form.Label>Manyata Photo</Form.Label>
                <Form.Control
                  type="file"
                  name="vaiyaktikManyataPhoto"
                  onChange={handleFile_Change}
                  disabled={newTeacherItem.vaiyaktikManyata === "NO"}
                />
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group controlId="formTeacherPhoto">
                <Form.Label>Teacher Photo</Form.Label>
                <Form.Control
                  type="file"
                  name="teacherPhoto"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Button variant="primary" type="submit">Save Changes</Button>
          &nbsp;
          <Button variant="secondary" onClick={handleCloseNewTeacher}>Close</Button>

        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddNewTeacherModal;
